import { type Currency } from "~/api/products/types";
import { T } from "@repo/transifex";
import { priceFormatter } from "~/utils/price-formatter";

import { BasketHeaderText } from "../basket-header-text";

export type HeaderBalanceProps = {
  balance: number | null;
  currency: Currency;
  locale: string;
};

export const HeaderBalance = ({
  balance,
  currency,
  locale
}: HeaderBalanceProps) => {
  if (typeof balance !== "number") {
    return null;
  }

  return (
    <span className="inline-flex gap-1">
      <BasketHeaderText>
        <T _str="Balance" />
      </BasketHeaderText>

      <BasketHeaderText variant={balance > 0 ? "positive" : "negative"}>
        {priceFormatter({
          value: balance,
          currency,
          locale
        })}
      </BasketHeaderText>
    </span>
  );
};
